import type TrailFeature from '@alltrails/types/TrailFeature';

// Source of truth for the feature filter values (order = display/chip order).
export const features: TrailFeature[] = [
  'waterfall',
  'views',
  'wild-flowers',
  'lake',
  'river',
  'forest',
  'wildlife',
  'beach',
  'cave',
  'hot-springs',
  'historic-site',
  'rails-trails',
  'city-walk',
  'pub-crawl',
  'event'
];

export const getValidFeatures = (feats: string[]) => feats.filter(feat => features.includes(feat as TrailFeature)) as TrailFeature[];
